<template>
  <div class="page p-wizard-step">
    <map-wizard :facets="['custom']">
      <template #navigation>
        <wizard-navigation
          :facets="['custom']"
          :get-route-link="getRouteLink"
          :progress-idx="mapConfig.wizardStepProgressIdx"
          :wizard-step="activeWizardStep"
          :wizard-step-list="activeWizardStepList"
          class="p-wizard-step__navigation"
        />
      </template>
      <template #step>
        <wizard-step :facets="['custom']" :wizard-step="activeWizardStep">
          <template #default>
            <component :is="activeWizardStep.component" v-if="mapConfig" :map-config="mapConfig" />
          </template>
        </wizard-step>
      </template>
      <template #map>
        <div class="p-wizard-step__persona-navigation">
          <persona-navigation />
        </div>
        <help-menu class="p-wizard-step__help-menu" />
        <world-map
          v-if="mapConfig"
          v-bind="mapConfig"
          :allow-rotation="activeWizardStep.allowRotation"
          :allow-zoom="activeWizardStep.allowZoom"
          :facets="[]"
          :map-padding="[4, 4, 4, 4]"
          :projection-morph-duration="400"
          class="p-wizard-step__map"
        />
      </template>
    </map-wizard>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import MapWizard from '@/components/map-wizard/map-wizard'
  import { mapConfigIds } from '@/assets/js/model/map-config'
  import WizardNavigation from '@/components/wizard-navigation/wizard-navigation'
  import WizardStep from '@/components/wizard-step/wizard-step'
  import HelpMenu from '@/components/help-menu/help-menu'
  import WorldMap from '@/components/world-map/world-map'
  import { interstitialContentList } from '@/assets/js/model/interstitial-content'
  import { pageIds } from '@/assets/js/model/page'
  import PersonaNavigation from '@/components/persona-navigation/persona-navigation'

  export default {
    meta: {
      pageId: pageIds.CUSTOM_WIZARD,
      titleKey: 'meta.wizard.title',
    },
    validator({ params }) {
      return !!params.step
    },
    components: { PersonaNavigation, WorldMap, HelpMenu, WizardStep, WizardNavigation, MapWizard },
    computed: {
      ...mapState('viewport', ['width']),
      ...mapState('world-map', ['mapConfigs']),
      ...mapGetters('navigation', ['activeWizardStep', 'activeWizardStepList']),
      mapConfig() {
        return this.mapConfigs[mapConfigIds.CUSTOM_WIZARD]
      },
      wizardStepProgressIdx() {
        return Math.max(
          this.mapConfig.wizardStepProgressIdx,
          this.interstitialContent
            ? this.interstitialContent.wizardStepIdx
            : Number.MAX_SAFE_INTEGER,
        )
      },
      interstitialContent() {
        const { id } = this.activeWizardStep
        return interstitialContentList.find(({ wizardStepId }) => wizardStepId === id)
      },
    },
    watch: {
      'activeWizardStep.id': {
        handler() {
          if (!process.client) {
            return
          }

          this.setMapConfig({
            ...this.mapConfig,
            wizardStepProgressIdx: this.wizardStepProgressIdx,
          })
        },
        immediate: true,
      },
    },
    methods: {
      ...mapActions('world-map', ['setMapConfig']),
      getRouteLink(param) {
        return this.localePath({
          name: 'wizard-step-step',
          params: { ...this.$route.params, step: param },
          query: this.$route.query,
        })
      },
    },
  }
</script>

<style lang="scss" src="@/assets/scss/pages/_p-wizard-step.scss" />
